import type { ThreadListView } from "@/features/threads/types";

export const threadKeys = {
  all: ["threads"] as const,
  lists: () => [...threadKeys.all, "list"] as const,
  list: (view: ThreadListView, generation = 0) =>
    [...threadKeys.lists(), view, generation] as const,
  detail: (rootPostContentId: number) =>
    [...threadKeys.all, "detail", rootPostContentId] as const,
  unreadSummary: () => [...threadKeys.all, "unread-summary"] as const,
  selectedUnreadSummary: (rootPostContentId: number) =>
    [...threadKeys.all, "selected-unread-summary", rootPostContentId] as const,
};
